// extracted by mini-css-extract-plugin
export var nameOfLink = "index-module--nameOfLink--33_WJ";
export var container = "index-module--container--3u_48";
export var icon = "index-module--icon--32j7q";
export var linksContainer = "index-module--linksContainer--2e4MR";
export var ghost = "index-module--ghost--2qzPh";